import * as checked from '../lib/checked';
import { DATASET_INSIGHT_TYPES as DatasetTypes_DATASET_INSIGHT_TYPES } from '../v2/dataset/datasetTypes';
export const DATASET_INSIGHT_DATASET_PREFIX = 'insights-dataset';

/**
 * @deprecated Import DATASET_INSIGHT_TYPES directly from 'reporting-data/v2/dataset/datasetTypes' instead.
 */
export const DATASET_INSIGHT_TYPES = DatasetTypes_DATASET_INSIGHT_TYPES;

/**
 * @deprecated Import DatasetInsightTypes directly from 'reporting-data/v2/dataset/datasetTypes' instead.
 */

export const DatasetInsightTypes = checked.symbol(DatasetTypes_DATASET_INSIGHT_TYPES, 'DATASET_INSIGHT_TYPES');
export const DatasetInsightMeta = checked.record({
  metricName: checked.string(),
  breakdownValue: checked.string().optional(),
  rangeName: checked.string().optional()
}, 'DatasetInsightMeta');
export const DatasetInsightOption = checked.record({
  insightType: checked.symbol(DATASET_INSIGHT_TYPES, 'DATASET_INSIGHT_TYPES').required()
}, 'DatasetInsightOption');
export const DatasetInsightParams = checked.record({
  insightOptions: checked.list(DatasetInsightOption).required()
}, 'DatasetInsightParams');